"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputStyles = exports.InputConfigs = void 0;
var _CalculatorProvider = require("./CalculatorProvider");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  InputConfigs = styles => {
    return {
      "currency": {
        InputProps: {
          startAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
            position: "start"
          }, /*#__PURE__*/_react.default.createElement("div", {
            style: styles.icon
          }, "$")),
          style: styles.input
        },
        inputProps: {
          maxLength: "6"
        }
      },
      "number": {
        InputProps: {
          style: styles.input
        },
        inputProps: {}
      },
      "percentage": {
        InputProps: {
          endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
            position: "end"
          }, /*#__PURE__*/_react.default.createElement("div", {
            style: styles.icon
          }, "%")),
          style: styles.input
        },
        inputProps: {
          maxLength: "5"
        }
      },
      "text": {
        InputProps: {
          style: styles.input
        },
        inputProps: {}
      }
    };
  },
  InputStyles = theme => {
    return {
      commponent: {
        display: "block"
      },
      icon: {
        backgroundColor: "#EAEAEB",
        color: "#5F6061",
        width: "4.5rem",
        textAlign: "center",
        height: "4.8rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: theme.fontFamilies.semiBold,
        fontSize: "2.4rem"
      },
      label: {
        textAlign: "left",
        color: "#5F6061",
        display: "block",
        fontFamily: theme.fontFamilies.semiBold,
        fontSize: "1.8rem",
        lineHeight: "2.222"
      },
      input: {
        height: "5rem",
        fontSize: "1.8rem",
        padding: 0
      }
    };
  };

/**
 * Calculator Input Field
 *
 * @visibleName Calculator Input
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.InputStyles = InputStyles;
exports.InputConfigs = InputConfigs;
const CalculatorInput = props => {
  const {
      className,
      customTheme = {},
      defaultValue,
      fullWidth = true,
      id,
      InputProps = {},
      inputMode = "numeric",
      inputProps = {},
      inputTemplate = "number",
      label,
      labelId,
      labelTag = "label",
      labelType = "static",
      name,
      onChange,
      placeholder,
      styles = {},
      testId,
      type = "text",
      value,
      variant = "outlined",
      ...rest
    } = props,
    compiledInputId = (0, _string.isStringOfLength)(id) ? id : `id_${name}`,
    compiledLabelId = (0, _string.isStringOfLength)(labelId) ? labelId : `${compiledInputId}_label`,
    calculatorTheme = _CalculatorProvider.Methods.useCustomTheme(),
    theme = merge.all([(0, _styles.useTheme)(), calculatorTheme, customTheme]),
    compositeClasses = (0, _classnames.default)({
      "calculator__input": true,
      [`calculator__input--is${inputTemplate.charAt(0).toUpperCase()}${inputTemplate.slice(1)}`]: (0, _string.isStringOfLength)(inputTemplate),
      [`${className}`]: className
    }),
    compositeStyles = merge(InputStyles(theme), {
      component: {
        ...styles
      }
    }),
    config = InputConfigs(compositeStyles);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compositeClasses,
    component: "div",
    "data-testid": testId,
    sx: compositeStyles.component
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    fullWidth: fullWidth
  }, labelType === "static" && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "calculator__input__static-label",
    component: labelTag,
    htmlFor: compiledInputId,
    id: compiledLabelId,
    sx: compositeStyles.label
  }, label), /*#__PURE__*/_react.default.createElement(_material.TextField, _extends({
    defaultValue: !value && defaultValue ? defaultValue : undefined,
    id: compiledInputId,
    InputProps: merge(config[inputTemplate].InputProps, InputProps),
    inputMode: inputMode,
    inputProps: merge.all([{
      "aria-labelledby": compiledLabelId
    }, config[inputTemplate].inputProps, inputProps]),
    label: labelType === "animated" ? label : undefined,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    sx: compositeStyles.input,
    type: type,
    value: value,
    variant: variant
  }, rest))));
};

// Define propTypes;
CalculatorInput.propTypes = {
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Theme object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Default value of input (for uncontrolled components) */
  defaultValue: _propTypes.default.string,
  /** Indicator if input should expand to full width (Default Value: true) */
  fullWidth: _propTypes.default.bool,
  /** Configuration Object for MUI Input component (Default Value: {}) */
  InputProps: _propTypes.default.object,
  /** Input attribute to hint at appropriate virtual keyboard (Default Value: "numeric") */
  inputMode: _propTypes.default.oneOf(["none", "text", "decimal", "numeric"]),
  /** Configuration Object for input element (Default Value: {}) */
  inputProps: _propTypes.default.object,
  /** Template to use for calculator input format/display (Default Value: "number") */
  inputTemplate: _propTypes.default.oneOf(["currency", "number", "percentage", "text"]),
  /** Label for input */
  label: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  /** ID for input */
  labelId: _propTypes.default.string,
  /** Tag for label node (Default Value: "static") */
  labelTag: _propTypes.default.string,
  /** MUI Label behavior type */
  labelType: _propTypes.default.oneOf(["animated", "static"]),
  /** Input name attribute */
  name: _propTypes.default.string.isRequired,
  /** Change event handler */
  onChange: _propTypes.default.func,
  /** Input placeholder attribute */
  placeholder: _propTypes.default.string,
  /** Styles object for the component (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Input type (Default Value: "text") */
  type: _propTypes.default.oneOf(["number", "text"]),
  /** Input value (for controlled components) */
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** MUI Text Field Variant (Default Value: "outlined") */
  variant: _propTypes.default.oneOf(["outlined", "filled", "standard"])
};

// Export component as default;
var _default = exports.default = CalculatorInput;